module.exports = __webpack_public_path__ + "i18n/zh-TW.70561aa6b26fce6550f457d60dede94d.json";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=i18n/[name].[hash].[ext]!./i18n/zh-TW.json
// module id = 1106
// module chunks = 76